    /**
     * 개발 테스트용 더미 OTP 목록
     */
    export const dummyOtpList = [
        {
            mName: 'Google Account',
            mAccount: 'user@gmail.com',
            mIssuer: 'Google',
            mSecret: 'JBSWY3DPEHPK3PXP',
            mAlgorithm: 'SHA1',
            mDigits: '6',
            mPeriod: '30',
            mIcon: ''
        },
        {
            mName: 'GitHub',
            mAccount: 'developer',
            mIssuer: 'GitHub',
            mSecret: 'KBSWY3DPEHPK3PXQ',
            mAlgorithm: 'SHA1',
            mDigits: '6',
            mPeriod: '30',
            mIcon: ''
        },
        {
            mName: 'AWS Console',
            mAccount: 'admin@company.com',
            mIssuer: 'AWS',
            mSecret: 'LBSWY3DPEHPK3PXR',
            mAlgorithm: 'SHA1',
            mDigits: '6',
            mPeriod: '30',
            mIcon: ''
        },
        {
            mName: 'Microsoft 365',
            mAccount: 'user@outlook.com',
            mIssuer: 'Microsoft',
            mSecret: 'MBSWY3DPEHPK3PXS',
            mAlgorithm: 'SHA1',
            mDigits: '6',
            mPeriod: '30',
            mIcon: ''
        }
    ];


    /**
     * otpauth 샘플 
     */

    /**
    otpauth://totp/Google:user@gmail.com?secret=JBSWY3DPEHPK3PXP&issuer=Google&algorithm=SHA1&digits=6&period=30
    otpauth://totp/GitHub:developer?secret=KBSWY3DPEHPK3PXQ&issuer=GitHub&algorithm=SHA1&digits=6&period=30
    otpauth://totp/AWS:admin@company.com?secret=LBSWY3DPEHPK3PXR&issuer=AWS&algorithm=SHA1&digits=6&period=30
     */

    /**
     * 파라미터	필수	기본값	설명
     */

    /**
    secret	✅	-	Base32 인코딩된 시크릿 키
    issuer	❌	-	서비스 제공자 이름
    algorithm	❌	SHA1	SHA1, SHA256, SHA512
    digits	❌	6	OTP 자릿수 (6 또는 8)
    period	❌	30	갱신 주기 (초)
     */

